import Header from "@/components/landing/Header";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function KontaktPage() {
  return (
    <>
      <Seo
        title="Kontakt: Kostenloses Erstgespräch buchen"
        description="Sprechen wir über Ihren Neustart in Florida: Schreiben Sie uns oder buchen Sie Ihr kostenloses Erstgespräch – persönlich und auf Deutsch. Telefon +1 305 529 4140."
        keywords="Erstgespräch Auswanderung, Kontakt Auswanderungsberatung, Beratung Florida kostenlos, Auswandern Florida Kontakt"
      />
      <Header />
      <main className="pt-20" data-testid="kontakt-page">
        <Contact />
      </main>
      <Footer />
    </>
  );
}
